const EgyptSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111357)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="black"
      />
      <path
        d="M26.9566 17.8261H21.7392C21.7392 16.8656 20.9605 16.0869 20 16.0869C19.0396 16.0869 18.2609 16.8656 18.2609 17.8261H13.0435C13.0435 18.7866 13.8801 19.5652 14.8406 19.5652H14.7826C14.7826 20.5257 15.5612 21.3043 16.5217 21.3043C16.5217 22.2649 17.3003 23.0435 18.2609 23.0435H21.7392C22.6997 23.0435 23.4783 22.2649 23.4783 21.3043C24.4388 21.3043 25.2174 20.5257 25.2174 19.5652H25.1595C26.12 19.5652 26.9566 18.7866 26.9566 17.8261Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111357">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EgyptSvg;
